import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import CloseButton from '../close-button';
import './styles.scss';
import Spinner from '../spinner';
import styles from './customerservice.js';

const CustomerService = props => {

    const [isOpen, toggleOpen] = useState(false);
    const [url, setUrl] = useState(undefined);
    const [isLoading, setLoading] = useState(true);
    const iframeRef = useRef(null);

    useEffect(() => {
        iframeRef.current.addEventListener('load', () => {
            iframeRef.current.contentWindow.postMessage({styles: styles()}, 'https://kundservice.dabas.com');

            window.addEventListener('message', event => {
				if (event.origin.endsWith('https://kundservice.dabas.com')) {	
                    if (event.data.type === 'unload') {
                        setLoading(true);
                    }

                    if (event.data.type === 'load') {
                        setLoading(false);
                    }
				}   
				return;
			});
        });
    }, []);

    useEffect(() => {
        if (isOpen && !url) {
            setUrl('https://kundservice.dabas.com');
        }
    }, [isOpen, url]);

    return (
        <div className={classNames({
            'customer-service': true,
            ...props.modifiers
        })}>
            <button 
                className="customer-service__trigger" 
                onClick={() => {
                    toggleOpen(!isOpen);
                }}><span>Support</span></button>
            <div className={classNames({
                'customer-service__container': true,
                'customer-service__container--is-open': isOpen,
                'customer-service__container--is-loading': isLoading
            })} onClick={(e) => {
                if (e.target === e.currentTarget) {
                    toggleOpen(false);
                }
            }}>
                <div className="customer-service__container-inner">
                    <iframe 
                        ref={iframeRef}
                        id="testar"
                        className={classNames({
                            'customer-service__frame': true
                        })}
                        title="Delfi Kundservice"
                        src={url} />
                    <CloseButton onClick={() => toggleOpen(!isOpen)} text="Stäng" />
                    <Spinner />
                </div>
            </div>
        </div>
    );
};

export default CustomerService;